import React, {useEffect, useState} from "react";
import axios from "axios";
import {Backdrop, CircularProgress} from "@mui/material";
import Grid from "@mui/material/Grid";
import {NormalButton} from "../Components/NormalButton";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from '@mui/icons-material/Close';
import Box from "@mui/material/Box";
import {useHistory} from "react-router-dom";
import { useMemo } from "react";
import {getTicketData} from "../Global";

const RenderMappedSeats = ({ mappingData, ticketGroups, history, setViewSeat }) => {
    const overlays = useMemo(() => {
        console.log(mappingData)
        return mappingData.map((mapping, index) => {
            const { ticket_type, coordinates, type, not_exists } = mapping;

            // Check if this ticket_type exists in any group
            let foundGroupID = null;
            let foundTicketType = null;

            console.log(ticketGroups)
            console.log("GROUPS!")

            for (const [groupID, group] of Object.entries(ticketGroups)) {
                // @ts-ignore
                const ticketMatch = group.tickets.find(t => t.ticketType === ticket_type);
                if (ticketMatch) {
                    foundGroupID = groupID;
                    foundTicketType = ticket_type;
                    break;
                }
            }

            const [x, y, r] = coordinates.map(Number); // Remember: x/y switched in your box usage

            if (type === "circle") {
                if (foundGroupID) {
                    const coords = coordinates.join(",");
                    console.log(`AREA ${coords}`)
                    return (
                        <Box
                            key={index}
                            onClick={() => {
                                const params = new URLSearchParams(history.location.search);
                                params.set("ticketType", foundTicketType);
                                params.set("selectedTicket", foundGroupID);
                                history.push({
                                    pathname: "./single-quantity",
                                    search: `?${params.toString()}`
                                });
                                setViewSeat(false);
                            }}
                            sx={{
                                position: "absolute",
                                top: y - r,
                                left: x - r,
                                width: r * 2,
                                height: r * 2,
                                borderRadius: "50%",
                                display: "flex",
                                bgcolor: "rgba(0, 0, 0, 0.0)",
                                cursor: "pointer",
                                transition: "background-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
                                '&:hover': {
                                    bgcolor: "rgba(0, 0, 0, 0.5)"
                                }
                            }}
                        />
                    );
                } else {
                    return (
                        <Box
                            key={index}
                            sx={{
                                position: "absolute",
                                top: y - r,
                                left: x - r,
                                width: r * 2,
                                height: r * 2,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: "red",
                                opacity: 0.9,
                                pointerEvents: "none",
                            }}
                        >
                            {!not_exists ? (
                                <CloseIcon sx={{ color: "white", fontSize: r * 1.2 }} />
                            ) : (
                                <PersonIcon sx={{ color: "white", fontSize: r * 1.2 }} />
                            )}
                        </Box>
                    );
                }
            }

            // Reserved for future rectangle logic
            if (type === "rect") {
                const [x1, y1, x2, y2] = coordinates.map(Number);
                const top = y1;
                const left = x1;
                const width = x2 - x1;
                const height = y2 - y1;

                if (foundGroupID) {
                    const coords = coordinates.join(",");
                    return (
                        <Box
                            key={index}
                            onClick={() => {
                                const params = new URLSearchParams(history.location.search);
                                params.set("ticketType", foundTicketType);
                                params.set("selectedTicket", foundGroupID);
                                history.push({
                                    pathname: "./single-quantity",
                                    search: `?${params.toString()}`
                                });
                                setViewSeat(false);
                            }}
                            sx={{
                                position: "absolute", top, left, width, height, borderRadius: 4, display: "flex", cursor: "pointer", transition: "background-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
                                '&:hover': {
                                    bgcolor: "rgba(0, 0, 0, 0.5)"
                                }
                            }}
                        />
                    );
                } else {
                    return (
                        <Box
                            key={index}
                            sx={{
                                position: "absolute",
                                top,
                                left,
                                width,
                                height,
                                borderRadius: 4, // rounded corners
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: "red",
                                opacity: 0.9,
                                pointerEvents: "none",
                            }}
                        >
                            {!not_exists ? (
                                <CloseIcon sx={{ color: "white", fontSize: Math.min(width, height) * 0.6 }} />
                            ) : (
                                <PersonIcon sx={{ color: "white", fontSize: Math.min(width, height) * 0.6 }} />
                            )}
                        </Box>
                    );
                }
            }

            return null;
        });
    }, [mappingData, ticketGroups, history, setViewSeat]);

    return (
        <>
            <map name="seatmap">{overlays}</map>
            {overlays.filter(el => el?.type === undefined)} {/* overlays are Box elements */}
        </>
    );
};

export const SeatMap: React.VFC< {viewSeat: boolean, setViewSeat: any} > = (props) => {
    const [imageHref, setImageHref] = useState("");
    const [loaded, setLoaded] = useState(false);
    const [data, setData] = useState([]);
    const [time, setTime] = useState("")

    const history = useHistory();

    useEffect(() => {
        const url = new URL(window.location.href);
        const eventID = url.pathname.split("/")[1]
        console.log(`EVENT ID: ${eventID}`)

        const allEventData = JSON.parse(localStorage.getItem("eventData"));
        const eventData = allEventData[eventID];

        setImageHref(eventData["seatmap-image"])
    }, []);

    useEffect(() => {
        const url = new URL(window.location.href);
        const eventID = url.pathname.split("/")[1]

        console.log(props.viewSeat)
        if (props.viewSeat && !loaded) {
            setLoaded(false);
            axios.post("https://ywdjj0mi04.execute-api.eu-west-2.amazonaws.com/Prod/get-mapping", {
                "eventID": eventID !== undefined ? eventID : ""
            }).then((res) => {
                setLoaded(true);
                setData(res.data.data.data);
                console.log(res.data.data.data);
                console.log("DATA GOT FROM SERVER")
            })
        }
    })

    return (
        <Backdrop style={{ color: "#inherit", zIndex: 1 }} open={props.viewSeat}>
            <Grid container direction={"column"} alignItems={"center"} spacing={1.5} maxHeight={"100vh"}>
                <Grid item container direction={"column"} alignItems={"center"} spacing={0.5}>
                    <Grid item>
                        {(!loaded && <CircularProgress color="warning"/>)}
                        {(loaded &&
                            <Box position="relative" display="inline-block" sx={{
                                maxHeight: "80vh",
                                maxWidth: "90vw",
                                overflow: "auto",
                            }}>
                                <img src={imageHref}  alt="Seat Map" useMap={"#seatmap"} style={{ display: "block" }}/>

                                {loaded && <RenderMappedSeats  mappingData={data} ticketGroups={getTicketData("", "groupData")} history={history} setViewSeat={props.setViewSeat} />}
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Grid item container direction={"row"} justifyContent={"center"} spacing={1.5}>
                    <Grid item>
                        <NormalButton thin style={{width: "150px", color: "#d7a02a"}} onClick={() => {setLoaded(false); props.setViewSeat(false)}}>Close</NormalButton>
                    </Grid>
                </Grid>
            </Grid>
        </Backdrop>
    )
}
